var map = {
	"./daniel-zacatenco-6rv0t2VjQR4-unsplash-1920.jpg": 32008,
	"./graham-holtshausen-fUnfEz3VLv4-unsplash-1920.jpg": 91232,
	"./joe-yates-Cc4sToR2Oc0-unsplash-1920.jpg": 67566,
	"./sean-foley-kMpbE_-jCeI-unsplash-1920.jpg": 82368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77964;